import React from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import RadioInput from 'src/hook-form/radio-input';

interface Props {
  rules?: any;
  name: string;
  label: string;
  required?: boolean;
  defaultValue?: any;
  helper?: string;
  items: {value: any; label: string}[];
}

const HookFormRadioInput = (props: Props) => {
  const {control} = useFormContext();
  return (
    <Controller
      control={control}
      rules={props.rules}
      render={({field, fieldState: {error}}) => (
        <RadioInput {...props} {...field} error={error} />
      )}
      name={props.name}
      defaultValue={props.defaultValue}
    />
  );
};

export default HookFormRadioInput;
